import { render, staticRenderFns } from "./NotificationsUser.vue?vue&type=template&id=6fa6bdd7&scoped=true"
import script from "./NotificationsUser.vue?vue&type=script&lang=js"
export * from "./NotificationsUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6bdd7",
  null
  
)

export default component.exports